// extracted by mini-css-extract-plugin
export default {"block":"Utility_block__K8FSM","cards":"Utility_cards__Km01Q","card":"Utility_card__f+0XG","ul":"Utility_ul__at4fw","title":"Utility_title__BDiNR","ul1":"Utility_ul1__kaNIV"};